import { handleResponse, handleError } from "./apiUtils";
import { API, graphqlOperation } from 'aws-amplify';
import * as queries from '../graphql/queries';
import * as mutations from '../graphql/mutations';

export async function createMeal(parameters) {
  parameters.IPAddress = '27.0.0.1';
  console.log(parameters); // debug
  let response = await API.graphql(graphqlOperation(mutations.mealApIcreateMeal, parameters))
    .catch(handleError);

  // console.log(response.data.mealAPIcreateMeal) // debug
  return response.data.mealAPIcreateMeal;
}

export async function updateMeal(parameters) {
  parameters.IPAddress = '27.0.0.1';
  let response = await API.graphql(graphqlOperation(mutations.mealApIupdateMeal, parameters))
    .catch(handleError);

  // console.log(response.data.mealAPIcreateMeal) // debug
  return response.data.mealAPIupdateMeal;
}

export async function getMeal(parameters) {
  let response = await API.graphql(graphqlOperation(queries.mealApIgetMeal, parameters))
    .catch(handleError);

  // console.log(response.data.mealAPIcreateMeal) // debug
  return response.data.mealAPIgetMeal;
}

export async function deleteMeal(parameters) {
  parameters.IPAddress = '27.0.0.1';
  let response = await API.graphql(graphqlOperation(mutations.mealApIdeleteMeal, parameters))
    .catch(handleError);

  return response.data.mealAPIdeleteMeal;
}



// WEBPACK FOOTER //
// ./src/api/mealApi.js